import AppState from 'AppState';
//#region Smo
import { DefaultTenantKey } from 'features/tenants/Constants';
import { isNullOrEmptyGuid } from '~/components/shared/Utils';
//#endregion Smo

/**
 * Get the tenant id for the current tab
 */
export const getCurrentTenantId = () => {
    return AppState.tenantId;
};

/**
 * Gets the current tenant base url.
 */
export const getCurrentTenantBaseUrl = () => {
    return AppState.tenantBaseUrl;
};

//#region Smo
/**
 * Sets the default tenant id to the session and local storages.
 * Local storage is used to keep the default tenant so that we can use it across tabs.
 * Session storage is used to keep the default tenant and use it for ajax calls.
 */
export const setDefaultTenantIdToSessionAndLocalStorage = (tenantId: string) => {
    // Empty Guid means there is no tenant the user can access within the request.
    if (isNullOrEmptyGuid(tenantId)) {
        return;
    }

    sessionStorage.setItem(DefaultTenantKey, tenantId);
    localStorage.setItem(DefaultTenantKey, tenantId);
};

/**
 * Get the default tenant id from session or local storage.
 */
export const getDefaultTenantIdFromSessionOrLocalStorage = () => {
    return sessionStorage.getItem(DefaultTenantKey) ?? localStorage.getItem(DefaultTenantKey);
};

/**
 * Determine whether we are administering the default tenant
 */
export const isDefaultTenant = () => {
    const defaultId = getDefaultTenantIdFromSessionOrLocalStorage();
    const currentId = getCurrentTenantId();

    return defaultId === currentId;
}
//#endregion Smo